import { DynamoDBClient } from "@aws-sdk/client-dynamodb";
import {
  DynamoDBDocumentClient,
  QueryCommand,
} from "@aws-sdk/lib-dynamodb";
import { fetchAuthSession } from "aws-amplify/auth";

// env
const {
  REACT_APP_REGION,
  REACT_APP_PARTNERS_TABLENAME,
} = process.env;

const queryTable = async (awsCredentials) => {
  const docClient = DynamoDBDocumentClient.from(
    new DynamoDBClient({
      region: REACT_APP_REGION,
      credentials: awsCredentials,
    }),
  );

  // build command
  const params = {
    TableName: REACT_APP_PARTNERS_TABLENAME,
    IndexName: 'status-index',
    Limit: 15,
    KeyConditionExpression: '#status = :status',
    ProjectionExpression: '\
      #account_id, \
      #application_location, \
      #date_of_birth, \
      #individual, \
      #electrical_competency, \
      #created, \
      #modified\
    ',
    ExpressionAttributeNames: {
      '#status': 'status',
      '#account_id': 'account_id',
      '#application_location': 'application_location',
      '#date_of_birth': 'date_of_birth',
      '#individual': 'individual',
      '#electrical_competency': 'electrical_competency',
      '#created': 'created',
      '#modified': 'modified',
    },
    ExpressionAttributeValues: {
      ':status': 'ACTIVE',
    },
  };

  const command = new QueryCommand(params);
  const res = await docClient.send(command);
  return res.Items || [];
};

const handler = async (_, { rejectWithValue }) => {
  try {
    const { credentials } = await fetchAuthSession();
    const partners = await queryTable(credentials);

    return partners;
  } catch (error) {
    console.error(
      'services.partners.getActivePartners@handler',
      error,
    );

    return rejectWithValue(error);
  }
};

const pending = (state) => {
  return {
    ...state,
    loading: true,
  };
};

const fulfilled = (state, action) => {
  return {
    ...state,
    loading: false,
    lists: action.payload,
  };
};

const rejected = (state) => {
  return {
    ...state,
    loading: false,
  };
};

export default {
  handler,
  pending,
  fulfilled,
  rejected,
};
